/**
 * BrewNectar Product Final CTA — fade-up + smooth scroll to offers anchor
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initFadeUp(root) {
    if (root.classList.contains('bn-pcta--static')) {
      root.querySelectorAll('.bn-pcta__animate').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var animated = root.querySelectorAll('.bn-pcta__animate');

    if (
      prefersReducedMotion() ||
      !('IntersectionObserver' in window) ||
      (typeof Shopify !== 'undefined' && Shopify.designMode)
    ) {
      animated.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var rootMargin = root.getAttribute('data-bn-pcta-observer-margin') || '-60px 0px';
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: rootMargin, threshold: 0 }
    );

    animated.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initSmoothScroll(root) {
    var links = root.querySelectorAll('[data-bn-pcta-smooth-scroll]');
    if (!links.length) return;

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;

        var target = document.getElementById(href.slice(1));
        if (!target) return;

        event.preventDefault();
        if (window.BrewNectarScroll) {
          window.BrewNectarScroll.scrollToElement(target);
        } else {
          target.scrollIntoView({
            behavior: prefersReducedMotion() ? 'auto' : 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.bnPctaInit === 'true') return;
    root.dataset.bnPctaInit = 'true';

    initFadeUp(root);
    initSmoothScroll(root);
  }

  function initAll() {
    document.querySelectorAll('.bn-pcta').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.bn-pcta');
    if (root) initRoot(root);
  });
})();
